export default __webpack_public_path__ + "static/media/QI.842d787d.png";